import { useState } from 'react';
import LocationPickerField from '../../../../Direcciones/LocationPickerField';
const fields = [
  { key: 'tipoVia', label: 'TIPO DE VÍA', type: 'select' },
  { key: 'nombreVia', label: 'NOMBRE DE VÍA', type: 'text', placeholder: 'Ej: LOS LAURELES', autoComplete: 'address-line1' },
  { key: 'numeroMz', label: 'N°/MZ-LT', type: 'text', placeholder: 'Ej: 123, MZ A LT 1', maxLength: 10 },
  { key: 'urbanizacion', label: 'URBANIZACIÓN/CASERÍO', type: 'text', placeholder: 'Ej: CHOCÁN, LA ORCA', autoComplete: 'address-line2' },
];

const tipoViaOptions = [
  { value: '', label: 'SELECCIONE...' },
  { value: 'CALLE', label: 'CALLE' },
  { value: 'AV.', label: 'AV.' },
  { value: 'JR.', label: 'JR.' },
  { value: 'TRANSVERSAL', label: 'TRANSVERSAL' },
  { value: 'PASAJE', label: 'PASAJE' },
  { value: 'RURAL', label: 'RURAL' },
  { value: 'BARRIO', label: 'BARRIO' },
  { value: 'OTRO', label: 'OTRO' },
  { value: 'KM', label: 'KM' },
  { value: 'ZONA', label: 'ZONA' },
  { value: 'SECTOR', label: 'SECTOR' },
  { value: 'VÍA', label: 'VÍA' },
  { value: 'PROLONGACIÓN', label: 'PROLONGACIÓN' },
  { value: 'CARRETERA', label: 'CARRETERA' },
  { value: 'ALAMEDA', label: 'ALAMEDA' },
  { value: 'MALECÓN', label: 'MALECÓN' },
];
const formatNombre = (nombre) => {
  return nombre
    .replace(/_/g, ' ')
};

const DireccionCorrespondencia = ({
  direccion,
  peruData,
  errors,
  onChange,
  onCopyFromFiscal,
  onClearCorrespondencia,
}) => {
  const [ligado, setLigado] = useState(false);

  const inputClass = (field) =>
    `w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 ${
      errors[`direccionCorrespondencia.${field}`] ? 'border-red-500 ring-2 ring-red-100' : 'border-slate-300'
    }`;

  const handleDepartamentoChange = (e) => {
    onChange('direccionCorrespondencia.departamento', e.target.value);
    onChange('direccionCorrespondencia.provincia', '');
    onChange('direccionCorrespondencia.distrito', '');
  };

  const handleProvinciaChange = (e) => {
    onChange('direccionCorrespondencia.provincia', e.target.value);
    onChange('direccionCorrespondencia.distrito', '');
  };

  const handleUppercaseChange = (name, value) => {
    onChange(name, value.toUpperCase());
  };

  return (
    <div className="ui-card p-5 md:p-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 pb-3">
        <div className="flex items-center gap-3">
          <div className="h-8 w-1.5 rounded-full bg-red-600" />
          <h3 className="text-base font-semibold uppercase tracking-[0.08em] text-slate-800">DIRECCIÓN DE CORRESPONDENCIA/NEGOCIO</h3>
        </div>

        {/* ⬇️ Toggle: marcar = copiar, desmarcar = limpiar */}
        <label className="flex items-center text-xs font-semibold uppercase tracking-[0.08em] text-slate-600 cursor-pointer select-none">
          <input
            type="checkbox"
            className="mr-2"
            checked={ligado}
            onChange={(e) => {
              const checked = e.target.checked;
              setLigado(checked);
              if (checked) {
                onCopyFromFiscal && onCopyFromFiscal();
              } else {
                onClearCorrespondencia && onClearCorrespondencia();
              }
            }}
          />
          Igual a dirección fiscal
        </label>
      </div>

      {/* Campos SIEMPRE editables */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {fields.map(({ key, label, type, placeholder, autoComplete, maxLength }) => (
          <div key={key}>
            <label htmlFor={`direccionCorrespondencia-${key}`} className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
              {label}
            </label>
            {type === 'select' ? (
              <select
                id={`direccionCorrespondencia-${key}`}
                name={`direccionCorrespondencia.${key}`}
                value={direccion?.[key] || ''}
                onChange={(e) => onChange(e.target.name, e.target.value)}
                className={inputClass(key)}
                aria-invalid={!!errors[`direccionCorrespondencia.${key}`]}
              >
                {tipoViaOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            ) : (
              <input
                id={`direccionCorrespondencia-${key}`}
                name={`direccionCorrespondencia.${key}`}
                value={direccion?.[key] || ''}
                onChange={(e) => handleUppercaseChange(e.target.name, e.target.value)}
                placeholder={placeholder}
                autoComplete={autoComplete}
                maxLength={maxLength}
                className={inputClass(key)}
                aria-invalid={!!errors[`direccionCorrespondencia.${key}`]}
                style={{ textTransform: 'uppercase' }}
              />
            )}
            {errors[`direccionCorrespondencia.${key}`] && (
              <p className="mt-1 text-xs font-medium text-red-600">{errors[`direccionCorrespondencia.${key}`]}</p>
            )}
          </div>
        ))}

        {/* Departamento */}
        <div>
          <label htmlFor="direccionCorrespondencia-departamento" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            DEPARTAMENTO
          </label>
          <select
            id="direccionCorrespondencia-departamento"
            name="direccionCorrespondencia.departamento"
            value={direccion?.departamento || ''}
            onChange={handleDepartamentoChange}
            className={inputClass('departamento')}
            aria-invalid={!!errors['direccionCorrespondencia.departamento']}
          >
            <option value="">SELECCIONE...</option>
            {Object.keys(peruData).map((depto) => (
              <option key={depto} value={depto}>
                {formatNombre(depto)}
              </option>
            ))}
          </select>
          {errors['direccionCorrespondencia.departamento'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['direccionCorrespondencia.departamento']}</p>
          )}
        </div>

        {/* Provincia */}
        <div>
          <label htmlFor="direccionCorrespondencia-provincia" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            PROVINCIA
          </label>
          <select
            id="direccionCorrespondencia-provincia"
            name="direccionCorrespondencia.provincia"
            value={direccion?.provincia || ''}
            onChange={handleProvinciaChange}
            disabled={!direccion?.departamento}
            className={inputClass('provincia')}
            aria-invalid={!!errors['direccionCorrespondencia.provincia']}
          >
            <option value="">SELECCIONE...</option>
            {direccion?.departamento &&
              Object.keys(peruData[direccion.departamento]).map((prov) => (
                <option key={prov} value={prov}>
                  {formatNombre(prov)}
                </option>
              ))}
          </select>
          {errors['direccionCorrespondencia.provincia'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['direccionCorrespondencia.provincia']}</p>
          )}
        </div>

        {/* Distrito */}
        <div>
          <label htmlFor="direccionCorrespondencia-distrito" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            DISTRITO
          </label>
          <select
            id="direccionCorrespondencia-distrito"
            name="direccionCorrespondencia.distrito"
            value={direccion?.distrito || ''}
            onChange={(e) => onChange(e.target.name, e.target.value)}
            disabled={!direccion?.provincia}
            className={inputClass('distrito')}
            aria-invalid={!!errors['direccionCorrespondencia.distrito']}
          >
            <option value="">SELECCIONE...</option>
            {direccion?.departamento &&
              direccion?.provincia &&
              peruData[direccion.departamento][direccion.provincia].map((dist) => (
                <option key={dist} value={dist}>
                  {dist}
                </option>
              ))}
          </select>
          {errors['direccionCorrespondencia.distrito'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['direccionCorrespondencia.distrito']}</p>
          )}
        </div>
      </div>
      <LocationPickerField
        direccion={direccion}
        fieldPrefix="direccionCorrespondencia"
        errors={errors}
        onChange={onChange}
      />
    </div>
  );
};

export default DireccionCorrespondencia;
